import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=1e10981c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e10981c')) {
      api.createRecord('1e10981c', component.options)
    } else {
      api.reload('1e10981c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=1e10981c&", function () {
      api.rerender('1e10981c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28e3WUjVL6GD6/JS/comp/childrenage.vue"
export default component.exports